import React from "react";
import styled from "styled-components";
import { MIN_MORNITOR_WIDTH } from "../../constants";
import { theme } from "../../../theme";

const MainContainer: React.FC = ({ children }) => {
  return <StyledContainer>{children}</StyledContainer>;
};

export default MainContainer;
const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100vh;

  z-index: 0;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    flex-direction: column;
    height: 100vh;

    background: ${theme.colors.white};
    justify-content: center;
  }
`;
